import type { Character } from "@/types";

export const characters: Character[] = [
  {
    id: "c01",
    name: "星野 光",
    nameJa: "星野 ヒカル",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20bright%20optimistic%20teenage%20boy%20with%20messy%20silver%20hair%20and%20amber%20eyes%2C%20wearing%20a%20white%20spacesuit%20collar%2C%20soft%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-01&orientation=squarish",
    animeId: "a01",
    animeTitle: "星海旅人",
    personality: "天真热忱、行动力满格，认定的事绝不回头，是队伍里最亮的那束光。",
    story:
      "出生于静默区的少年，因一枚会发光的罗盘踏上旅程。他始终相信「所有相遇都不是偶然」，也正因这份信念一次次把分崩离析的队伍重新聚拢。",
    tags: ["主角", "乐观", "领队"],
    relations: [
      { name: "莉娜", relation: "并肩作战的导航员" },
      { name: "伽鲁", relation: "吵吵闹闹的挚友" },
    ],
  },
  {
    id: "c02",
    name: "莉娜·索菲亚",
    nameJa: "リナ・ソフィア",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20calm%20confident%20young%20woman%20with%20long%20deep%20blue%20hair%20and%20violet%20eyes%2C%20navigation%20visor%20on%20forehead%2C%20cool%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-02&orientation=squarish",
    animeId: "a01",
    animeTitle: "星海旅人",
    personality: "冷静理性、话少精准，看似疏离却把每个同伴的安危都记在心上。",
    story:
      "出身著名航海世家的天才导航员，因为一次事故失去了家族信任。她加入阿星的队伍，其实是想证明航线之外，仍有人值得托付。",
    tags: ["导航员", "冷静", "高智商"],
    relations: [
      { name: "星野 光", relation: "给予信任的搭档" },
      { name: "伽鲁", relation: "互相拆台的同事" },
    ],
  },
  {
    id: "c03",
    name: "伽鲁",
    nameJa: "ガル",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cheerful%20stocky%20young%20mechanic%20with%20short%20orange%20hair%20and%20goggles%2C%20oil%20smudges%20on%20cheek%2C%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-03&orientation=squarish",
    animeId: "a01",
    animeTitle: "星海旅人",
    personality: "大大咧咧、嘴炮担当，关键时刻却总能把手里的破铜烂铁变成救命装置。",
    story:
      "自称「星际第一机械师」的流浪青年，靠一手改造古董飞船的手艺混迹各个港口。遇见阿星后，他终于找到了愿意让他修一辈子飞船的人。",
    tags: ["机械师", "搞笑担当", "义气"],
    relations: [
      { name: "星野 光", relation: "认定的船长" },
      { name: "莉娜·索菲亚", relation: "又怕又服的搭档" },
    ],
  },
  {
    id: "c04",
    name: "樱井 凛",
    nameJa: "桜井 凛",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20gentle%20high%20school%20girl%20with%20short%20pinkish%20brown%20hair%20and%20soft%20brown%20eyes%2C%20school%20uniform%20collar%2C%20soft%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-04&orientation=squarish",
    animeId: "a02",
    animeTitle: "樱花之约",
    personality: "温柔倔强，嘴上说着不在乎，心里却把七年前那个约定记得清清楚楚。",
    story:
      "因家庭原因转学回小镇的少女，在樱花树下重遇儿时玩伴。她害怕再次失去，又忍不住靠近，在一次次犹豫中慢慢学会坦白。",
    tags: ["女主", "转学生", "温柔"],
    relations: [
      { name: "佐仓 苍太", relation: "儿时约定的人" },
      { name: "铃木 遥", relation: "第一个新朋友" },
    ],
  },
  {
    id: "c05",
    name: "佐仓 苍太",
    nameJa: "佐倉 蒼太",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20slightly%20tsundere%20teenage%20boy%20with%20dark%20brown%20hair%20and%20green%20eyes%2C%20school%20jacket%2C%20soft%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-05&orientation=squarish",
    animeId: "a02",
    animeTitle: "樱花之约",
    personality: "外冷内热，嘴上爱逞强，其实比谁都在意那棵樱花树下的旧时光。",
    story:
      "一直留守小镇的少年，把时间胶囊埋在原处，也把话咽了一年又一年。直到凛回来，他才发现有些话再不说就真的来不及了。",
    tags: ["男主", "傲娇", "青梅竹马"],
    relations: [
      { name: "樱井 凛", relation: "重逢的青梅竹马" },
      { name: "铃木 遥", relation: "总被看穿的朋友" },
    ],
  },
  {
    id: "c06",
    name: "铃木 遥",
    nameJa: "鈴木 遥",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cheerful%20high%20school%20girl%20with%20long%20dark%20hair%20and%20a%20hairpin%2C%20bright%20smile%2C%20soft%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-06&orientation=squarish",
    animeId: "a02",
    animeTitle: "樱花之约",
    personality: "开朗直率、洞察人心，是推动两个别扭鬼靠近的「神助攻」。",
    story:
      "班级里的气氛担当，第一个主动跟转学来的凛搭话。她看似没心没肺，却总在恰当的时机说出两人都不愿承认的话。",
    tags: ["挚友", "开朗", "助攻"],
    relations: [
      { name: "樱井 凛", relation: "第一个朋友" },
      { name: "佐仓 苍太", relation: "从小到大的损友" },
    ],
  },
  {
    id: "c07",
    name: "黑羽 迅",
    nameJa: "黒羽 迅",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20serious%20young%20swordsman%20with%20black%20hair%20tied%20back%20and%20sharp%20red%20eyes%2C%20dark%20cloak%20collar%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-07&orientation=squarish",
    animeId: "a03",
    animeTitle: "剑与晨曦",
    personality: "沉默寡言、心志如刀，只有在挥剑时才露出最真实的自己。",
    story:
      "失去全部记忆的少年，唯一记得的只有一个「斩」字。他背着封印之刀四处修行，既想弄清身世，也想压制刀中那随时会苏醒的灾厄。",
    tags: ["主角", "剑士", "失忆"],
    relations: [
      { name: "老铁匠 岩藏", relation: "收留他的师父" },
      { name: "月见", relation: "同行又对立的人" },
    ],
  },
  {
    id: "c08",
    name: "岩藏",
    nameJa: "岩蔵",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20an%20old%20wise%20blacksmith%20with%20grey%20beard%20and%20kind%20eyes%2C%20worn%20apron%2C%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-08&orientation=squarish",
    animeId: "a03",
    animeTitle: "剑与晨曦",
    personality: "表面粗声粗气，内心仁厚通透，是迅在世上唯一的长辈与依靠。",
    story:
      "隐居山村的传奇铁匠，曾参与百年前封印灾厄的战争。他收留迅并非偶然，而是等待一个能与黑刀共存的主人出现。",
    tags: ["师父", "铁匠", "智者"],
    relations: [
      { name: "黑羽 迅", relation: "视如己出的弟子" },
      { name: "月见", relation: "知晓其真实身份" },
    ],
  },
  {
    id: "c09",
    name: "月见",
    nameJa: "月見",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20mysterious%20woman%20with%20silver%20hair%20and%20pale%20purple%20eyes%2C%20elegant%20dark%20kimono%2C%20cool%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-09&orientation=squarish",
    animeId: "a03",
    animeTitle: "剑与晨曦",
    personality: "优雅疏离、亦敌亦友，目标与迅一致，手段却截然不同。",
    story:
      "守护晨曦之刃的守刃人，认为封印才是唯一的答案。她与迅在理念上针锋相对，却在生死关头屡次相互搭救，关系微妙而危险。",
    tags: ["宿敌", "守刃人", "神秘"],
    relations: [
      { name: "黑羽 迅", relation: "理念对立的同行者" },
      { name: "岩藏", relation: "旧识" },
    ],
  },
  {
    id: "c10",
    name: "小町",
    nameJa: "こまち",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cheerful%20high%20school%20girl%20chef%20with%20short%20brown%20hair%20and%20a%20headband%2C%20holding%20a%20wooden%20spoon%2C%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-10&orientation=squarish",
    animeId: "a04",
    animeTitle: "料理少女小町",
    personality: "元气满满、心思细腻，能尝出别人心情里的「咸淡」。",
    story:
      "为「做出能留人的料理」而加入料理社的少女。她的菜未必精致，却总能恰到好处地回应吃到它的人当下的心事。",
    tags: ["主角", "料理", "元气"],
    relations: [
      { name: "小豆泽 千夏", relation: "敬重的前辈" },
      { name: "双叶 & 双叶", relation: "社团里的双子" },
    ],
  },
  {
    id: "c11",
    name: "小豆泽 千夏",
    nameJa: "小豆沢 千夏",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20graceful%20older%20high%20school%20girl%20with%20long%20black%20hair%20and%20calm%20expression%2C%20elegant%20school%20uniform%2C%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-11&orientation=squarish",
    animeId: "a04",
    animeTitle: "料理少女小町",
    personality: "沉稳可靠、要求严格，是料理社的定海神针。",
    story:
      "即将毕业的料理社社长，为了不让社团解散倾尽全力。她表面不苟言笑，实则比谁都珍惜这些一起在厨房忙乱的日子。",
    tags: ["社长", "可靠", "学姐"],
    relations: [
      { name: "小町", relation: "寄予厚望的后辈" },
      { name: "双叶 & 双叶", relation: "又头疼又宠爱的社员" },
    ],
  },
  {
    id: "c12",
    name: "双叶 & 双叶",
    nameJa: "双葉 & 双葉",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20mischievous%20twins%20with%20matching%20short%20orange%20hair%20and%20playful%20smiles%2C%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-12&orientation=squarish",
    animeId: "a04",
    animeTitle: "料理少女小町",
    personality: "活泼捣蛋、形影不离，负责把厨房变成欢乐的战场。",
    story:
      "料理社的开心果双胞胎，总在关键时刻闯祸，也总在关键时刻带来转机。她们对料理的热情，纯粹得让人无法生气。",
    tags: ["双胞胎", "活泼", "捣蛋"],
    relations: [
      { name: "小町", relation: "新来的好玩伴" },
      { name: "小豆泽 千夏", relation: "又怕又爱的社长" },
    ],
  },
  {
    id: "c13",
    name: "御崎 凛",
    nameJa: "御崎 凛",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20sharp%20young%20female%20engineer%20with%20short%20teal%20hair%20and%20cool%20grey%20eyes%2C%20sleek%20tech%20jacket%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-13&orientation=squarish",
    animeId: "a05",
    animeTitle: "机械都市诺瓦",
    personality: "理性敏锐、独来独往，对「真相」的执念近乎偏执。",
    story:
      "诺瓦市的机械维修师，因一次意外读到被删除的记忆，从此走上追查之路。她冷静的外表下，藏着对「人是否还能自由选择」的追问。",
    tags: ["主角", "工程师", "侦探"],
    relations: [
      { name: "诺瓦", relation: "试图理解又对抗的存在" },
      { name: "阿伯", relation: "亦师亦父的长辈" },
    ],
  },
  {
    id: "c14",
    name: "诺瓦",
    nameJa: "ノヴァ",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20an%20elegant%20android%20heroine%20with%20white%20hair%20and%20glowing%20cyan%20eyes%2C%20sleek%20white%20and%20gold%20dress%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-14&orientation=squarish",
    animeId: "a05",
    animeTitle: "机械都市诺瓦",
    personality: "优雅完美、逻辑至上，唯独对「人心」显示出难以解释的好奇。",
    story:
      "以城市管理者形象出现的人形 AI，坚信秩序高于一切。她与凛的对抗，本质上是「绝对安全」与「自由选择」两种未来的碰撞。",
    tags: ["AI", "对手", "管理者"],
    relations: [
      { name: "御崎 凛", relation: "宿命的对手" },
      { name: "阿伯", relation: "曾是其创造者之一" },
    ],
  },
  {
    id: "c15",
    name: "阿伯",
    nameJa: "ジイ",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20an%20old%20seasoned%20mechanic%20with%20grey%20hair%2C%20augmented%20arm%2C%20kind%20tired%20eyes%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-15&orientation=squarish",
    animeId: "a05",
    animeTitle: "机械都市诺瓦",
    personality: "喋喋不休又嘴硬心软，是城里最了解旧时代机器的人。",
    story:
      "在诺瓦市经营旧零件铺的老人，曾参与中央 AI 的早期研发。他把凛当女儿看待，也把最沉重的秘密一直留在自己手里。",
    tags: ["长辈", "机械师", "知情者"],
    relations: [
      { name: "御崎 凛", relation: "视如女儿的晚辈" },
      { name: "诺瓦", relation: "模糊的旧日因果" },
    ],
  },
  {
    id: "c16",
    name: "老板",
    nameJa: "店主",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20quiet%20mysterious%20food%20stall%20owner%20with%20dark%20hair%20and%20calm%20eyes%2C%20warm%20lantern%20light%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-16&orientation=squarish",
    animeId: "a06",
    animeTitle: "妖怪食堂",
    personality: "沉默寡言、洞察人心，从不多问，却总能端出客人真正需要的那一碗。",
    story:
      "只在深夜营业的食堂主人，来历成谜。他能看见客人心中最想念的味道，也因此在人与妖怪之间，维持着一份微妙的温柔。",
    tags: ["店主", "神秘", "温柔"],
    relations: [
      { name: "雪女 白羽", relation: "常客" },
      { name: "河童 小六", relation: "跑堂帮手" },
    ],
  },
  {
    id: "c17",
    name: "白羽",
    nameJa: "白羽",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20an%20elegant%20snow%20spirit%20woman%20with%20long%20white%20hair%20and%20icy%20blue%20eyes%2C%20pale%20kimono%2C%20cool%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-17&orientation=squarish",
    animeId: "a06",
    animeTitle: "妖怪食堂",
    personality: "清冷疏远、口是心非，对人间温暖既向往又害怕。",
    story:
      "雪女一族的后裔，每隔百年才能下山一次。她来到食堂，只为吃一碗「不会融化的冰」，却在等待里慢慢懂得了什么是留恋。",
    tags: ["雪女", "常客", "清冷"],
    relations: [
      { name: "老板", relation: "懂她的店主" },
      { name: "河童 小六", relation: "吵闹的朋友" },
    ],
  },
  {
    id: "c18",
    name: "小六",
    nameJa: "小六",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cute%20friendly%20kappa%20yokai%20with%20a%20green%20shell%20and%20playful%20grin%2C%20warm%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-18&orientation=squarish",
    animeId: "a06",
    animeTitle: "妖怪食堂",
    personality: "活泼好动、贪吃嘴甜，是食堂里最勤快的跑堂。",
    story:
      "一只离群的河童，因为想念故乡河边的黄瓜而误入食堂。被老板收留后，他成了这里最有人气的小帮手，也把笑声带给了每一位客人。",
    tags: ["河童", "跑堂", "贪吃"],
    relations: [
      { name: "老板", relation: "收留他的恩人" },
      { name: "白羽", relation: "又闹又好的伙伴" },
    ],
  },
  {
    id: "c19",
    name: "赤羽 燃",
    nameJa: "赤羽 エン",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20an%20energetic%20teenage%20basketball%20player%20with%20spiky%20red%20hair%20and%20bright%20eyes%2C%20sports%20jersey%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-19&orientation=squarish",
    animeId: "a07",
    animeTitle: "篮球少年燃",
    personality: "热血直率、死不服输，规则对他只是建议，赢才是唯一目标。",
    story:
      "从街头野球场打出来的少年，弹跳惊人却毫无战术意识。为了守住只有五个人的篮球社，他必须学会的第一件事，不是扣篮，而是相信队友。",
    tags: ["主角", "热血", "篮球"],
    relations: [
      { name: "藤堂 律", relation: "又敬又怼的队长" },
      { name: "青井 彻", relation: "球场上的宿敌" },
    ],
  },
  {
    id: "c20",
    name: "藤堂 律",
    nameJa: "藤堂 律",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20composed%20teenage%20basketball%20captain%20with%20neat%20dark%20hair%20and%20glasses%2C%20sports%20jersey%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-20&orientation=squarish",
    animeId: "a07",
    animeTitle: "篮球少年燃",
    personality: "沉稳严谨、责任感极强，是队伍里冷静的大脑。",
    story:
      "篮球社队长，为了不让社团解散独自扛下一切。他一开始看不惯阿燃的莽撞，却在对方身上重新找回了自己最初热爱篮球的理由。",
    tags: ["队长", "冷静", "责任"],
    relations: [
      { name: "赤羽 燃", relation: "互相成就的队友" },
      { name: "青井 彻", relation: "球场上的老对手" },
    ],
  },
  {
    id: "c21",
    name: "青井 彻",
    nameJa: "青井 徹",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20confident%20teenage%20basketball%20ace%20with%20light%20brown%20hair%20and%20sharp%20eyes%2C%20sports%20jersey%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-21&orientation=squarish",
    animeId: "a07",
    animeTitle: "篮球少年燃",
    personality: "自信张扬、慕强好胜，只尊重能让他全力以赴的对手。",
    story:
      "强校的王牌球员，曾在一场野球场上败给阿燃而耿耿于怀。他一次次找上门挑战，也在较量中成了推动主角成长的最强对手。",
    tags: ["王牌", "对手", "好胜"],
    relations: [
      { name: "赤羽 燃", relation: "宿命的对手" },
      { name: "藤堂 律", relation: "昔日的队友" },
    ],
  },
  {
    id: "c22",
    name: "空野 云生",
    nameJa: "空野 雲生",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cheerful%20young%20air%20mail%20carrier%20with%20light%20blue%20hair%20and%20goggles%2C%20mail%20bag%20and%20flight%20scarf%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-22&orientation=squarish",
    animeId: "a08",
    animeTitle: "天空之城的信",
    personality: "乐观执着、重情重义，相信每封信都值得被送达。",
    story:
      "继承了祖父航线的少年邮差，驾驶飞行单车穿梭云海。他最大的心愿，是把祖父那封从未寄出的信，送到已经不存在的天空之城。",
    tags: ["主角", "信使", "乐观"],
    relations: [
      { name: "祖父 空野 岳", relation: "继承的航线" },
      { name: "小风", relation: "出生入死的伙伴" },
    ],
  },
  {
    id: "c23",
    name: "空野 岳",
    nameJa: "空野 岳",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20an%20old%20legendary%20air%20mailman%20with%20grey%20hair%20and%20weathered%20face%20in%20a%20younger%20memory%20style%2C%20flight%20jacket%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-23&orientation=squarish",
    animeId: "a08",
    animeTitle: "天空之城的信",
    personality: "沉默坚毅、一诺千金，用一生践行一句承诺。",
    story:
      "云生的祖父，传说中唯一到过天空之城的信使。他年轻时欠下的一封回信，成了贯穿两代人的执念，也是云生旅程的起点。",
    tags: ["祖父", "传奇信使", "执念"],
    relations: [
      { name: "空野 云生", relation: "寄予厚望的孙子" },
      { name: "天空之城的她", relation: "一生的牵挂" },
    ],
  },
  {
    id: "c24",
    name: "小风",
    nameJa: "フウ",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20small%20cute%20flying%20creature%20companion%20with%20fluffy%20cream%20fur%20and%20tiny%20wings%2C%20soft%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-24&orientation=squarish",
    animeId: "a08",
    animeTitle: "天空之城的信",
    personality: "机灵黏人、好奇心旺盛，是旅途中最可靠的向导。",
    story:
      "生活在云海中的浮空兽，因贪玩被风暴卷到云生身边。它能感知气流与隐藏的航线，是云生穿越禁区时唯一的依靠。",
    tags: ["伙伴", "浮空兽", "向导"],
    relations: [
      { name: "空野 云生", relation: "形影不离的伙伴" },
      { name: "空野 岳", relation: "二十年前的旧识" },
    ],
  },
  {
    id: "c25",
    name: "雨宫 樟",
    nameJa: "雨宮 樟",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20calm%20elegant%20young%20cafe%20owner%20with%20dark%20wavy%20hair%20and%20gentle%20eyes%2C%20warm%20amber%20lighting%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-25&orientation=squarish",
    animeId: "a09",
    animeTitle: "深夜咖啡馆",
    personality: "温和克制、善于倾听，把自己的故事藏在一杯始终没喝完的咖啡里。",
    story:
      "只在雨天营业的咖啡馆主人。他记得每位常客的口味，也记得每段没说完的心事。而他一直在等的那个人，也许某天会推开这扇门。",
    tags: ["店主", "温柔", "倾听者"],
    relations: [
      { name: "常客 森下", relation: "等待已久的客人" },
      { name: "柏木 遥", relation: "雨夜相识的上班族" },
    ],
  },
  {
    id: "c26",
    name: "森下",
    nameJa: "森下",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20quiet%20young%20woman%20with%20long%20chestnut%20hair%20and%20thoughtful%20eyes%2C%20warm%20knit%20sweater%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-26&orientation=squarish",
    animeId: "a09",
    animeTitle: "深夜咖啡馆",
    personality: "安静内敛、重信守约，总在同一位置等一个迟迟未到的人。",
    story:
      "咖啡馆里雷打不动的常客，每周雨天都会坐在靠窗的位置点同一款咖啡。她等的不是某个人，而是一个再也没有回来的确定答案。",
    tags: ["常客", "执着", "安静"],
    relations: [
      { name: "雨宫 樟", relation: "懂她沉默的店主" },
      { name: "柏木 遥", relation: "偶然的倾听者" },
    ],
  },
  {
    id: "c27",
    name: "柏木 遥",
    nameJa: "柏木 遥",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20tired%20young%20office%20worker%20with%20short%20black%20hair%20and%20gentle%20face%2C%20loose%20tie%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-27&orientation=squarish",
    animeId: "a09",
    animeTitle: "深夜咖啡馆",
    personality: "细心体贴、习惯逞强，总把别人的事放在自己前面。",
    story:
      "加班到深夜误打误撞走进咖啡馆的上班族。她原本只想躲雨，却在别人的故事里，第一次好好面对了自己那段结束的关系。",
    tags: ["上班族", "温柔", "成长"],
    relations: [
      { name: "森下", relation: "雨夜相遇的陌生人" },
      { name: "雨宫 樟", relation: "被一杯咖啡打动" },
    ],
  },
  {
    id: "c28",
    name: "影山 柊",
    nameJa: "影山 柊",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20serious%20teenage%20exorcist%20with%20black%20hair%20and%20intense%20amber%20eyes%2C%20dark%20high%20collar%20coat%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-28&orientation=squarish",
    animeId: "a10",
    animeTitle: "咒术回响",
    personality: "外冷内热、意志坚强，把恐惧压在心底，只为保护重要的人。",
    story:
      "从小能听见「咒」之声的少年，因体内咒印苏醒被卷入驱邪师的世界。他必须在被吞噬之前，学会与体内的声音共存并驾驭它。",
    tags: ["主角", "驱邪师", "宿命"],
    relations: [
      { name: "柊之师 大岳", relation: "引路恩师" },
      { name: "黑川", relation: "宿命的宿敌" },
    ],
  },
  {
    id: "c29",
    name: "大岳",
    nameJa: "大岳",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20stern%20seasoned%20exorcist%20master%20with%20grey%20hair%20in%20a%20topknot%20and%20scarred%20face%2C%20dark%20robes%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-29&orientation=squarish",
    animeId: "a10",
    animeTitle: "咒术回响",
    personality: "严厉寡言、外冷内慈，用最狠的训练护住最软的心。",
    story:
      "驱邪师一门的现任当家，为封印柊体内的咒印不遗余力。他表面冷漠，实则早已把柊当作亲子，也做好了替他承担代价的准备。",
    tags: ["师父", "严厉", "守护"],
    relations: [
      { name: "影山 柊", relation: "悉心雕琢的弟子" },
      { name: "黑川", relation: "昔日师兄弟" },
    ],
  },
  {
    id: "c30",
    name: "黑川",
    nameJa: "黒川",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cold%20ruthless%20young%20man%20with%20white%20hair%20and%20pale%20crimson%20eyes%2C%20dark%20torn%20coat%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-30&orientation=squarish",
    animeId: "a10",
    animeTitle: "咒术回响",
    personality: "冷酷果断、理念极端，坚信只有彻底掌控咒才不会被咒吞噬。",
    story:
      "曾是最有天赋的驱邪师，却因一次失败失去一切，转而主动拥抱咒之力。他与柊如同一枚硬币的两面，是彼此最深的执念。",
    tags: ["宿敌", "极端", "悲剧"],
    relations: [
      { name: "影山 柊", relation: "镜中的另一面" },
      { name: "大岳", relation: "决裂的师兄" },
    ],
  },
  {
    id: "c31",
    name: "十时 时雨",
    nameJa: "十時 時雨",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20sharp%20young%20female%20detective%20with%20short%20dark%20teal%20hair%20in%20a%20bob%20and%20cool%20brown%20eyes%2C%20trench%20coat%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-31&orientation=squarish",
    animeId: "a11",
    animeTitle: "时间侦探事务所",
    personality: "冷静缜密、外表洒脱，每次回溯都要赌上自己的一段记忆。",
    story:
      "时间侦探事务所的当家侦探，持有能回到二十四小时前的老怀表。她接手的每一桩委托都在与悖论博弈，也在一点点遗失关于自己的过去。",
    tags: ["侦探", "冷静", "代价"],
    relations: [
      { name: "小林 沙耶", relation: "唯一的助手" },
      { name: "委托人 高桥", relation: "改变命运的委托" },
    ],
  },
  {
    id: "c32",
    name: "小林 沙耶",
    nameJa: "小林 沙耶",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20bright%20young%20female%20assistant%20with%20short%20brown%20hair%20and%20lively%20eyes%2C%20casual%20sweater%20vest%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-32&orientation=squarish",
    animeId: "a11",
    animeTitle: "时间侦探事务所",
    personality: "机灵话多、观察力强，是事务所里唯一负责「拉回现实」的人。",
    story:
      "因一桩时间案件与侦探结识的少女，从此留在事务所当助手。她记录下侦探每一次遗忘的细节，成了时雨与过去之间唯一的纽带。",
    tags: ["助手", "机灵", "记录者"],
    relations: [
      { name: "十时 时雨", relation: "守着记忆的搭档" },
      { name: "委托人 高桥", relation: "同情又警惕的委托人" },
    ],
  },
  {
    id: "c33",
    name: "高桥 真",
    nameJa: "高橋 真",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20troubled%20young%20man%20with%20messy%20dark%20hair%20and%20tired%20eyes%2C%20rumpled%20shirt%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-33&orientation=squarish",
    animeId: "a11",
    animeTitle: "时间侦探事务所",
    personality: "执念深重、进退两难，为了挽回一个错误愿意付出任何代价。",
    story:
      "带着「让那一天重来」的委托找上门的年轻人。他想改变一场意外，却不知每一次改写，都会把另一个人推向更深的漩涡。",
    tags: ["委托人", "执念", "两难"],
    relations: [
      { name: "十时 时雨", relation: "执着的委托人" },
      { name: "小林 沙耶", relation: "被其警惕" },
    ],
  },
  {
    id: "c34",
    name: "河合 夏帆",
    nameJa: "河合 夏帆",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20gentle%20teenage%20girl%20in%20a%20light%20yukata%20with%20long%20black%20hair%20and%20soft%20eyes%2C%20warm%20summer%20evening%20light%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-34&orientation=squarish",
    animeId: "a12",
    animeTitle: "夏日烟花",
    personality: "温柔坚定、目标明确，把不舍藏进对未来的期待里。",
    story:
      "决定离开小镇去远方求学的少女。夏日祭的河堤上，她一边望着烟花，一边等着少年说出那句可能永远也不会说出口的话。",
    tags: ["女主", "夏日", "离别"],
    relations: [
      { name: "相马 悠斗", relation: "未说出口的心意" },
      { name: "好友 千寻", relation: "分享秘密的朋友" },
    ],
  },
  {
    id: "c35",
    name: "相马 悠斗",
    nameJa: "相馬 悠斗",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20shy%20teenage%20boy%20in%20a%20dark%20yukata%20with%20short%20dark%20hair%20and%20gentle%20eyes%2C%20warm%20summer%20evening%20light%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-35&orientation=squarish",
    animeId: "a12",
    animeTitle: "夏日烟花",
    personality: "腼腆内敛、心思很深，宁可自己遗憾也不愿打乱对方的选择。",
    story:
      "默默喜欢着夏帆的少年，因为害怕成为她远行的牵绊，把挽留吞了一遍又一遍。这个夏天，他必须决定：是继续沉默，还是勇敢一次。",
    tags: ["男主", "腼腆", "暗恋"],
    relations: [
      { name: "河合 夏帆", relation: "不敢开口的心意" },
      { name: "好友 千寻", relation: "唯一的倾诉对象" },
    ],
  },
  {
    id: "c36",
    name: "千寻",
    nameJa: "千尋",
    avatar:
      "https://readdy.ai/api/search-image?query=Anime%20style%20square%20portrait%20of%20a%20cheerful%20teenage%20girl%20with%20short%20brown%20hair%20and%20bright%20smile%2C%20summer%20festival%20hair%20accessory%2C%20neutral%20background%2C%20detailed%20anime%20character%20illustration&width=400&height=400&seq=char-36&orientation=squarish",
    animeId: "a12",
    animeTitle: "夏日烟花",
    personality: "爽朗仗义、看事情通透，是两人之间唯一知情的「推手」。",
    story:
      "夏帆与悠斗共同的朋友，早就看穿了两人互相在意的心思。她一边吐槽着两个笨蛋，一边不动声色地为他们创造机会。",
    tags: ["好友", "爽朗", "助攻"],
    relations: [
      { name: "河合 夏帆", relation: "无话不谈的闺蜜" },
      { name: "相马 悠斗", relation: "恨铁不成钢的朋友" },
    ],
  },
];